import { cn } from "@ui/utils";

type FilterCardMenuItemProps = {
  isSelected: boolean;
  onSelected: () => void;
  onKeyDown: () => void;
  title: string;
  children?: React.ReactNode;
};

export const FilterCardMenuItem = ({
  isSelected,
  onSelected,
  onKeyDown,
  title,
  children,
}: FilterCardMenuItemProps) => {
  const activeDataStyle =
    "relative top-0.5 flex h-full cursor-pointer flex-col items-center justify-end gap-1 px-4";

  return (
    <div
      className={cn(activeDataStyle, {
        "border-b-4 border-orange-600 pb-1": isSelected,
        "pb-2": !isSelected,
      })}
      onClick={onSelected}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
    >
      {children}
      <p
        className={cn(
          "whitespace-nowrap text-center text-base font-medium leading-relaxed text-gray-700",
          {
            "text-secondary-600": isSelected,
          }
        )}
      >
        {title}
      </p>
    </div>
  );
};
